// extracted by mini-css-extract-plugin
module.exports = {"button":"colorLabelDropdown_button__i2bYo","triggerWrapper":"colorLabelDropdown_triggerWrapper___Qjgv"};